module.exports = require("./es-MX");